import { EmptyResponseEntity } from "types/emptyResponseEntity";
import { type BTLoginTypes } from "types/enum";

import { APIHandler } from "utilities/apiHandler";

import {
    type ILinkEntityToAccountingGetRequest,
    type ILinkEntityToAccountingPutRequest,
    LinkToAccountingEntity,
} from "commonComponents/entity/accounting/common/accounting.api.types";
import { LinkedAccountingEntityResponse } from "commonComponents/entity/accounting/LinkedAccountingEntity/LinkedAccountingEntity.api.types";

export interface ILinkEntityToAccountingHandler {
    createAccountingEntity(req: ILinkEntityToAccountingPutRequest): Promise<EmptyResponseEntity>;
    getAccountingEntity(req: ILinkEntityToAccountingGetRequest): Promise<LinkToAccountingEntity>;
    saveAccountingEntity(req: ILinkEntityToAccountingPutRequest): Promise<EmptyResponseEntity>;
    getAccountingInfo(
        id: number,
        loginType: BTLoginTypes | undefined,
    ): Promise<LinkedAccountingEntityResponse>;
}

export class LinkEntityToAccountingHandler implements ILinkEntityToAccountingHandler {
    getAccountingEntity = async (req: ILinkEntityToAccountingGetRequest) => {
        return await APIHandler("/api/Accounting/AccountingEntity", {
            method: "GET",
            data: req,
            responseType: LinkToAccountingEntity,
        });
    };

    saveAccountingEntity = async (req: ILinkEntityToAccountingPutRequest) => {
        return await APIHandler("/api/Accounting/AccountingEntity", {
            method: "PUT",
            data: req,
            responseType: EmptyResponseEntity,
        });
    };

    createAccountingEntity = async (req: ILinkEntityToAccountingPutRequest) => {
        return await APIHandler("/api/Accounting/CreateAccountingEntity", {
            method: "PUT",
            data: req,
            responseType: EmptyResponseEntity,
        });
    };

    async getAccountingInfo(
        id: number,
        loginType: BTLoginTypes | undefined,
    ): Promise<LinkedAccountingEntityResponse> {
        return await APIHandler(`/api/Accounting/${id}/LinkedEntityInfo?loginType=${loginType}`, {
            method: "GET",
            responseType: LinkedAccountingEntityResponse,
        });
    }
}
